<template>
    <section>
        <o-field label="Small">
            <o-steps size="small">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>

        <o-field label="Default">
            <o-steps>
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>

        <o-field label="Medium">
            <o-steps size="medium">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>

        <o-field label="Large">
            <o-steps size="large">
                <o-step-item label="Account" icon="user-lock" clickable />
                <o-step-item label="Profile" icon="user" clickable />
                <o-step-item label="Social" icon="user-plus" clickable />
            </o-steps>
        </o-field>
    </section>
</template>
